import React, { useState, useEffect } from 'react';
import Icon from './AppIcon';
import { supabase } from '../lib/supabase';
import { useTranslation, Trans } from 'react-i18next'; // Dodat Trans za <br />

const QrCodeDipendente = ({ isOpen, onClose, data }) => {
  const { t } = useTranslation();
  const [badgeUrl, setBadgeUrl] = useState(null);
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    if (data && isOpen) {
      loadBadgeImage();
    }
    return () => cleanupUrl();
  }, [data, isOpen]);

  const cleanupUrl = () => {
    if (badgeUrl) {
      window.URL.revokeObjectURL(badgeUrl);
      setBadgeUrl(null);
    }
  };

  const loadBadgeImage = async () => {
    cleanupUrl();
    setIsFetching(true);
    
    try {
      const path = `${data.id_azienda}/${data.id}/badge/qrcode.png`;
      const { data: blob, error } = await supabase.storage
        .from('aziende')
        .download(path);

      if (error) {
        setBadgeUrl(null);
        return;
      }

      const url = window.URL.createObjectURL(blob);
      setBadgeUrl(url);
    } catch (err) {
      console.error("Errore caricamento badge:", err.message);
    } finally {
      setIsFetching(false);
    }
  };

  if (!isOpen || !data) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
      <div className="bg-card w-full max-w-sm rounded-3xl border border-border shadow-2xl overflow-hidden animate-in fade-in zoom-in duration-200">
        
        {/* Header */}
        <div className="p-6 border-b border-border flex justify-between items-center bg-muted/20">
          <div className="flex items-center gap-2">
            <Icon name="QrCode" size={20} className="text-primary" />
            <h3 className="font-bold text-lg uppercase tracking-tighter">{t('qrBadge.title')}</h3>
          </div>
          <button onClick={onClose} className="p-2 hover:bg-muted rounded-full transition-colors">
            <Icon name="X" size={20} />
          </button>
        </div>

        {/* Sadržaj */}
        <div className="p-8 flex flex-col items-center">
          <div className="w-full bg-muted/30 p-6 rounded-3xl border border-dashed border-border flex flex-col items-center justify-center min-h-[250px]">
            
            {isFetching ? (
              <div className="flex flex-col items-center gap-2">
                <div className="animate-spin text-primary"><Icon name="Loader2" size={40} /></div>
                <p className="text-[10px] font-bold text-muted-foreground uppercase">{t('qrBadge.loading')}</p>
              </div>
            ) : badgeUrl ? (
              <div className="space-y-6 text-center animate-in fade-in">
                <div className="bg-white p-3 rounded-2xl shadow-lg border border-border">
                  <img src={badgeUrl} alt={t('qrBadge.title')} className="w-48 h-48" />
                </div>
                <p className="text-[10px] font-black uppercase text-muted-foreground tracking-widest leading-tight">
                  <Trans i18nKey="qrBadge.instructions" />
                </p>
              </div>
            ) : (
              <div className="text-center space-y-4">
                <div className="opacity-10"><Icon name="QrCode" size={64} /></div>
                <p className="text-xs font-bold text-muted-foreground uppercase tracking-widest">
                  {t('qrBadge.notGenerated')}
                </p>
                <p className="text-[9px] text-muted-foreground px-4">
                  {t('qrBadge.contactAdmin')}
                </p>
              </div>
            )}
          </div>
        </div>

        {/* Footer */}
        <div className="p-6 bg-muted/10 border-t border-border">
          {badgeUrl ? (
            <a 
              href={badgeUrl} 
              download={`MioBadge_${data.cognome}.png`}
              className="w-full bg-primary text-white py-4 rounded-2xl font-bold flex items-center justify-center gap-2 hover:opacity-90 transition-all shadow-lg shadow-primary/20"
            >
              <Icon name="Download" size={18} /> {t('qrBadge.download')}
            </a>
          ) : (
            <button 
              onClick={onClose}
              className="w-full bg-muted text-muted-foreground py-4 rounded-2xl font-bold uppercase text-xs"
            >
              {t('qrBadge.close')}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default QrCodeDipendente;